import { Panel, Search } from '@ixicare/ui';
import * as React from 'react';
import { t } from '~/i18n';
import PermissionGrantedTable from './PermissionGrantedTable';

const PermissionGrantForm = () => {
  const [search, setSearch] = React.useState('');

  return (
    <div>
      <Panel.Title>{t('permissions.form.giveAccess')}</Panel.Title>
      <div className="row mb-25">
        <div className="col-10">
          <Search value={search} onSearchChange={setSearch} />
        </div>
        <div className="col-2"></div>
      </div>
      <PermissionGrantedTable />
    </div>
  );
};

export default PermissionGrantForm;
